module.exports = __webpack_public_path__ + "static/media/full-screen.0a7882d7.svg";